export const IDENTIFY_SETTLE_MS = 400;

export const IDENTIFY_STALE_MS = 60 * 1000;

export const PHONE_GROUP_AT = 5;
